<template>
  <oie-my-pages-template :title="t('orderHistoryTitle')" :text="t('orderHistorySubTitle')" class="my-order-history">
    <oie-my-order-history-navigation
      :orders="orders"
      :is-open="overlayVisible"
      :selected-order-id="selectedOrderId"
      @close="overlayVisible = false"></oie-my-order-history-navigation>
    <oie-accordion-tabs ref="tabs" name="order-history">
      <oie-accordion-tab :selected="openOrderRows === false" name="orders" :display-name="tStatic('orderHistoryTabText')">
        <div class="my-order-history__title">
          <h2>{{ tStatic('orderHistoryTabText') }}</h2>
        </div>
        <p class="my-order-history-title__text">
          {{ t('orderHistorySubheading') }}
        </p>

        <div>
          <div class="my-order-history__filter-grid">
            <!-- Sök o lägg till artiklar -->
            <oie-base-input
              id="my-order-history-search-order"
              v-model="searchPhrase"
              :label-text="tStatic('genericSearch')"
              epi-edit="'SearchPhraseDescription'"
              :placeholder="t('orderHistorySearchPlaceholder')"
              class="my-order-history__search-input"
              @input="search"></oie-base-input>

            <div class="input my-order-history__date-inputs">
              <label v-epi-edit="'FromDateHeader'" for="order-history-search-date-from" class="input__label">{{ t('fromDateLabel') }}</label>

              <div class="input__container">
                <datepicker
                  ref="fromDate"
                  v-model="fromDate"
                  :placeholder="t('fromDateLabel')"
                  :monday-first="true"
                  wrapper-class="datepicker"
                  calendar-class="datepicker-calendar"
                  input-class="datepicker-input"
                  format="yyyy-MM-dd"
                  :language="languages[0]"
                  :full-month-name="true"
                  @input="search"></datepicker>
              </div>
            </div>

            <div class="input my-order-history__date-inputs">
              <label v-epi-edit="'ToDateHeader'" for="order-history-search-date-from" class="input__label">{{ t('toDateLabel') }}</label>

              <div class="input__container">
                <datepicker
                  v-model="toDate"
                  :placeholder="t('toDateLabel')"
                  :monday-first="true"
                  wrapper-class="datepicker"
                  calendar-class="datepicker-calendar"
                  input-class="datepicker-input"
                  format="yyyy-MM-dd"
                  :language="languages[0]"
                  :full-month-name="true"
                  @input="search"></datepicker>
              </div>
            </div>
          </div>

          <div>
            <fieldset class="my-order-history__filter-actions">
              <legend class="sr-only">
                {{ t('orderHistoryFilter') }}
              </legend>
              <oie-base-radio-checkbox
                v-model="orderType"
                value="all"
                :label="t('showAllInvoicesFilterLabel')"></oie-base-radio-checkbox>

              <oie-base-radio-checkbox
                v-model="orderType"
                value="sent"
                :label="t('showSentOrdersLabel')"></oie-base-radio-checkbox>

              <oie-base-radio-checkbox
                v-model="orderType"
                value="open"
                :label="t('showOpenOrdersLabel')"></oie-base-radio-checkbox>
            </fieldset>
            <oie-action-wrapper>
              <oie-base-action theme="outlined-black" @click="openOrderRows = true">
                {{ t('showOpenOrderRowsLabel') }}
                <template #iconAppend>
                  <oie-base-icon icon="arrow-right" size="s"></oie-base-icon>
                </template>
              </oie-base-action>
            </oie-action-wrapper>
          </div>

          <section>
            <div class="my-order-history__title">
              <h2 v-epi-edit="'OrderListHeader'">
                {{ t('orderListHeader') }}
                <!-- Orderlista -->
              </h2>
            </div>

            <div class="my-order-history__table">
              <oie-order-history-product-table v-element-loader="{ endpoint: 'order/search' }" :orders="orders" @view-order="openOverlay"></oie-order-history-product-table>
            </div>
          </section>
        </div>
      </oie-accordion-tab>
      <oie-accordion-tab :selected="openOrderRows" name="ordered-articles" :display-name="tStatic('orderedArticlesTabText')">
        <div class="my-order-history__title">
          <h2>{{ tStatic('orderedArticlesTabText') }}</h2>
        </div>
        <p class="my-order-history-title__text">
          {{ t('orderHistoryArticlesSubheading') }}
        </p>

        <oie-ordered-articles-history :filter-by-not-sent="openOrderRows"></oie-ordered-articles-history>
      </oie-accordion-tab>
    </oie-accordion-tabs>
  </oie-my-pages-template>
</template>

<script>
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import { sv, de, sr } from 'vuejs-datepicker/dist/locale'
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  components: {
    Datepicker
  },
  data: () => ({
    languages: [sv, de, sr],
    fromDate: undefined,
    toDate: undefined,
    searchPhrase: '',
    sentOrders: false,
    openOrderRows: false,
    openOrders: false,
    orders: [],
    moreToGet: false,
    overlayVisible: false,
    selectedOrderId: null,
    orderType: 'all'
  }),
  watch: {
    orderType: function(newValue) {
      if (newValue === 'all') {
        this.sentOrders = false
        this.openOrders = false
      } else if (newValue === 'sent') {
        this.sentOrders = true
        this.openOrders = false
      } else if (newValue === 'open') {
        this.sentOrders = false
        this.openOrders = true
      }
      this.search()
    }
  },
  mounted() {
    this.toDate = new Date()
    this.fromDate = new Date()
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1)
    this.search()

    this.subscribe(`accordion-tab-changed`, (tabName) => {
      this.openOrderRows = false
    })
  },

  methods: {
    search: _.debounce(function() {
      httpService.post('order/search', { fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase, openOrders: this.openOrders, sentOrders: this.sentOrders }).then((response) => {
        this.orders = response.data.orders

        if (this.openOrderRows) {
          return
        }
        this.moreToGet = response.data.moreToGet
      })
    }, 300),

    openOverlay(order) {
      this.selectedOrderId = order.orderNr
      this.overlayVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.my-order-history {
  min-height: 35rem;

}
.my-order-history__filter-grid {
  display: grid;
  gap: measure(quarter);
  margin-bottom: measure(half);
  grid-template-columns: repeat(1, minmax(0, 1fr));

  @include media(medium) {
    grid-template-columns: minmax(0,40%) minmax(0,30%) minmax(0,30%)
  }
}

.my-order-history__search-input {
  grid-column: span 3;

  @include media(medium) {
    grid-column: span 1;
  }

}

.my-order-history__date-inputs {
  @include media(to-small) {
    grid-column: span 2;
  }
}

.my-order-history__column-header {
  @include h2-semi-bold;
  margin-top: 0;
  margin-bottom: measure(eighth) !important;
}

.my-order-history__filter-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: measure(full);

  @include media(small) {
    flex-direction: row;
    align-items: center;
  }
}

.my-order-history__filter-actions > * {
  @include media(to-small) {
      margin-bottom: measure(half);
  }

  @include media(large) {
    margin-right: measure(half);
  }
}

.my-order-history__date-search {
  width: 100%;

  @include media(small) {
    flex-basis: 9.375rem;
    width: auto;
    margin-left: measure(full);
  }

  @include media(medium) {
    align-self: flex-end;
  }
}

.my-order-history__table {
  overflow-x: auto;
}

.my-order-history__title >:first-child {
  @include h3-semi-bold;
  margin-bottom: measure(quarter);
}

.my-order-history-title__text {
  margin: measure(quarter) 0 measure(half) 0;
}

</style>
